/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
// CONSTANTS are all caps.
const NS = 'BioListItem';
const CLS = 'bioListItem';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/bioListItem.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import {initPageLoader} from '../bioPageLoader';

export class BioListItem {
	constructor($el) {
		// $el is the widget node return by the loadBioListItem function
		this.$el = $el;
	}

	init() {
		this.setBioListItem();
	}

	setBioListItem() {
		// Add Some logic here
		this.WG = WG;
		this.$wg = $(this.$el);
		this.name = this.$wg.data('name');

		this.loadingSpinner = $('.loading-spinner');
		this.pageLoaded = false;
		this.bioPage = this.$wg.find('.bioPage') || null;
		this.linkTrigger = this.$wg.find(WG + 'linkOverlay');

		initPageLoader(this);
	}

	// Add more functions like on above here
}
